import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State } from "./status.reducer";

export const GetState = createFeatureSelector<State>("appStatus");

export const GetRefreshState = createSelector(GetState, (state: State) => {
  return state.refreshState;
});
